import { LocationsState } from '../types';

export const locationsState: LocationsState = {
  /**
   * -------------------------------------
   * State for API request status
   * -------------------------------------
   */
  isInitializingFetchDataRequestPending: false, // This is the state of an API request to display the data in the Locations page.
  /**
   * -------------------------------------
   * State for the data source
   * -------------------------------------
   */
  vehicles: [],
  assetStatuses: [],
  selectedVehicle: null,
};
